const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isEmail = (value: string): boolean => {
  return !!value && EMAIL_PATTERN.test(value);
};
